module.exports = __webpack_public_path__ + "static/media/twovideos.ad641cd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twovideos.mp4
// module id = zfkq
// module chunks = 1